import {AddressDetails, AddressType} from '../models'

export const findPrimaryAddress = (data?: AddressDetails) =>
  data?.find(({type}) => type === AddressType.HOME) ?? data?.[0]

export const findPostalAddress = (data?: AddressDetails) =>
  data?.find(({type}) => type === AddressType.HOME)
    ? data?.find(({type}) => type === AddressType.POSTAL)
    : undefined
